<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <div class="flex justify-content-between">
          <div>
            <h5>РКН парсер</h5>
          </div>
          <div>
            <pulse-loader :loading="loading.parser" :color="$constants.LOADING_COLOR" class="text-center"/>
          </div>
          <div class="text-right">
            <button class="btn btn-default" type="button" @click="getParserData">Обновить</button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <template>
          <table class="table table-sm table-hover mt-0">
            <thead>
            <tr>
              <th>тип</th>
              <th>статус</th>
              <th>домен</th>
              <th>запросов</th>
              <th>ресурсов</th>
              <th>дата</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(p, alias, i) in parserData">
              <td>{{ parserTypes[alias] }}</td>
              <td>
                <span :class="`badge ${parserStatuses[p.status]?.class}`">
                  {{ parserStatuses[p.status] ? parserStatuses[p.status].title : '' }}
                </span>
              </td>
              <td>{{ p.domain && p.domain != '0' ? p.domain : null }}</td>
              <td>{{ p.attempts }}</td>
              <td>{{ p.total_links }}</td>
              <td>{{ p.created_at ? printDate(p.created_at) : 'н/д' }}</td>
            </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <h5>Новый прокси</h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col col-4">
            <label>Port</label>
            <input class="form-control" v-model="proxyForm.port">
          </div>
          <div class="col col-4">
            <label>Login</label>
            <input class="form-control" v-model="proxyForm.login">
          </div>
          <div class="col col-4">
            <label>Password</label>
            <input class="form-control" v-model="proxyForm.password">
          </div>
        </div>
        <div class="row mt-2" style="align-items: center;">
          <div class="col col-12">
            <label>IP</label>
            <div class="d-flex" style="gap: 10px;">
              <input class="form-control" v-model="proxyForm.ip" style="max-width: 460px;">
              <button class="btn btn-outline-primary" @click="addNewProxy()">Добавить</button>
            </div>
          </div>
        </div>
        <div class="row mt-2" style="gap: 10px;" v-for="(newItem, index) in proxyForm.items">
          <div class="col col-12">
            <small>{{ newItem.login }}:{{ newItem.password }} {{ newItem.port }}</small>
            <div class="d-flex" style="gap: 10px; align-items: center;">
              <input class="form-control" style="max-width: 460px;" v-model="newItem.value" :key="index">
              <span v-if="!newItem.is_invalid">OK</span>
              <span v-if="newItem.is_invalid && newItem.is_invalid !== -1" style="color: red;">ОШИБКА</span>
              <button @click="testNewProxy(index)" class="btn btn-outline-secondary">{{ loading.item === ('new' + index) ? 'Выполняется тест...' : 'Проверить' }}</button>
              <button @click="rmNewProxy(index)" class="btn btn-outline-danger">Удалить</button>
              <button @click="storeNewProxy(index)" v-if="!newItem.store" class="btn btn-xs btn-outline-success">Сохранить в БД</button>
              <span class="badge badge-success" v-if="newItem.store">Сохранено в БД</span>
            </div>
          </div>
        </div>
        <button v-if="proxyForm.items.length" @click="testNewProxy('all')" class="btn btn-outline-secondary mt-2">{{ loading.item === 'newAll' ? 'Выполняется тест...' : 'Проверить все' }}</button>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <h5>Список прокси</h5>
      </div>
      <div class="card-body">
        <pulse-loader :loading="loading.proxy" :color="$constants.LOADING_COLOR" class="text-center"/>
        <template v-if="!loading.proxy && proxyData">
          <table class="table table-hover table-sm mt-0">
            <thead>
            <tr>
              <th></th>
              <th>IP</th>
              <th>
                <label class="alt-source-chb"><input type="checkbox" v-model="altSource"><small>Альтернативный ресурс (новости rbc.ru)</small></label><br>
                тест валидности
                <button @click="testAll()" class="btn btn-xs btn-outline-secondary" style="margin-left: 6px;">{{ loading.item === 'all' ? 'Выполняется тест...' : 'Проверить все' }}<span class="badge badge-secondary" v-if="loading.item === 'all'">{{ stateCount }} / {{ proxyData.length }}</span></button>
              </th>
              <th style="text-align: right;">ошибки (повторные)</th>
              <th style="text-align: right;">добавлен</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(r,i) in proxyData" v-bind:class="{'has-error': r.errors >= 3 && !r.is_invalid, 'invalid': r.is_invalid, 'handled': handledIps.includes(r.ip)}">
              <td style="text-align: right;">{{ i + 1 }}</td>
              <td>{{ r.ip }}</td>
              <td>
                {{ r.is_invalid ? 'ОШИБКА' : 'OK' }}
                <button @click="testProxy(r)" class="btn btn-xs btn-outline-secondary" style="margin-left: 6px;">{{ loading.item === r.id ? 'Выполняется тест...' : 'Проверить' }}</button>
              </td>
              <td style="text-align: right;">{{ r.errors }}</td>
              <td style="text-align: right;">{{ r.created_at ? printDate(r.created_at, 'DD.MM.YYYY') : 'н/д' }}</td>
            </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/api'

export default {
  title: 'Proxy & Parser',
  data() {
    return {
      loading: {
        parser: false,
        proxy: false,
        item: false,
        saving: false,
      },
      handledIps: [],
      parserStatuses: {
        '-1': {title: 'ожидает сканирования', class: 'badge-primary'},
        0: {title: 'в процессе', class: 'badge-info'},
        1: {title: 'завершен', class: 'badge-success'},
        2: {title: 'отправлен отчет', class: 'badge-success'},
        4: {title: 'закрыт', class: 'badge-default'},
      },
      parserTypes: {
        'domain_check': 'Проверка SEO доменов',
        'duty_subdomains': 'Проверка расходных субдоменов',
        'single_url_check': 'Глубокая проверка домена',
      },
      parserData: [],
      proxyData: null,
      proxyForm: {
        port: null,
        login: null,
        password: null,
        ip: null,
        items: [],
      },
      stateCount: 0,
      altSource: false,
    }
  },
  created() {
    this.getParserData();
    this.getProxyData();
  },
  methods: {
    async getProxyData() {
      this.loading.proxy = true;
      this.proxyData = null;
      const {data} = await api.index('/new/services/proxy/stats');
      if (data.success) {
        this.proxyData = data.records;
        this.collectProxyData();
      } else {
        toastr['warning'](data.message ?? 'Ошибка загрузки данных прокси');
      }
      this.loading.proxy = false;
    },
    collectProxyData() {
      this.proxyData = _.orderBy(this.proxyData.map((r) => {
        return {...r}
      }), ['is_invalid', 'errors', 'ip'], ['desc', 'desc', 'asc']);

      console.log(this.proxyData);
    },
    addNewProxy: function () {
      if (this.proxyForm.ip) {
        this.proxyForm.items.push({
          value: this.proxyForm.ip.trim(),
          login: this.proxyForm.login.trim(),
          password: this.proxyForm.password.trim(),
          port: this.proxyForm.port.trim(),
          is_invalid: -1,
          stored: 0,
        });
        this.proxyForm.ip = null;
      }
    },
    rmNewProxy: function (index) {
      this.$delete(this.proxyForm.items, index);
    },
    async storeNewProxy(index) {
      if (this.loading.saving) {
        toastr['warning']('Дождитесь завершения сохранения');
        return false;
      }

      if (!confirm('')) {
        return false;
      }

      this.loading.saving = true;
      const {data} = await api.post('/new/services/proxy/store', this.proxyForm.items[index]);
      if (data.success) {
        toastr['success'](data.message ?? 'Success');
        this.proxyForm.items[index].store = 1;
      } else {
        toastr['error'](data.message ?? 'Error');
      }

      await this.getProxyData();

      this.loading.saving = false;
    },
    async getParserData() {
      this.loading.parser = true;
      // this.parserData = [];
      const {data} = await api.index('/new/services/parser/sessions');
      if (data.success) {
        this.parserData = data.records;
      } else {
        toastr['warning'](data.message ?? 'Ошибка загрузки данных парсера');
      }
      this.loading.parser = false;
    },
    async testState()
    {
      let stateInterval = setTimeout(async () => {
        const {data} = await api.index('/new/services/proxy/test-state');

        this.stateCount = data.count;

        if (data.items) {
          this.proxyData.forEach((item, index) => {
            if (data.items[item.ip] !== undefined) {
              item.is_invalid = data.items[item.ip];
              this.handledIps.push(item.ip);
            }
          });
        }

        if (data.success) {
          clearTimeout(stateInterval);
          this.loading.item = null;
          toastr['success']('Проверка завершена');
          this.stateCount = 0;
          setTimeout(() => {
            this.handledIps = [];
          }, 2500);
        } else {
          await this.testState();
        }
      }, 2500);
    },
    async testAll()
    {
      if (this.loading.item) {
        toastr['warning']('Дождитесь завершения проверки');
        return false;
      }

      this.loading.item = 'all';

      await api.index('/new/services/proxy/test-dispatch?altSource=' + this.altSource);

      await this.testState();
    },
    async testProxy(item) {
      if (this.loading.item) {
        toastr['warning']('Дождитесь завершения проверки');
        return false;
      }

      item = item || null;
      const id = item === null ? null : item.id;
      this.loading.item = item === null ? 'all' : item.id;

      const {data} = await api.post('/new/services/proxy/test', {id: id, altSource: this.altSource});
      if (data.success) {
        toastr['success'](data.message ?? 'Success');
        if (id) {
          item.is_invalid = 0;
        }
      } else {
        toastr['error'](data.message ?? 'Error');
        if (id) {
          item.is_invalid = 1;
        }
      }

      if (!id) {
        this.proxyData.forEach((item, index) => {
          item.is_invalid = data.items === undefined || data.items[item.id] === undefined || data.items[item.id].is_invalid ? 1 : 0;
        });
        this.collectProxyData();
      }

      this.loading.item = false;
    },
    async testNewProxy(index) {
      if (this.loading.item) {
        toastr['warning']('Дождитесь завершения проверки');
        return false;
      }

      this.loading.item = index === 'all' ? 'newAll' : ('new' + index);

      const items = index === 'all' ? this.proxyForm.items : {[index]: this.proxyForm.items[index]};
      const {data} = await api.post('/new/services/proxy/test', {items: items});
      if (data.success) {
        toastr['success'](data.message ?? 'Success');
      } else {
        toastr['error'](data.message ?? 'Error');
      }

      if (index === 'all') {
        this.proxyForm.items.forEach((item, key) => {
          item.is_invalid = data.items === undefined || data.items[key] === undefined || data.items[key].is_invalid ? 1 : 0;
        });
      } else {
        this.proxyForm.items[index].is_invalid = data.items === undefined || data.items[index] === undefined || data.items[index].is_invalid ? 1 : 0
      }

      this.loading.item = null;
    },
  }
}
</script>
<style>
tr.invalid {
  color: red;
}

tr.has-error {
  color: #b66205;
}

tr.handled {
  background: #eff0f6;
}

.table-hover tbody tr.invalid:hover {
  color: red;
}

.table-hover tbody tr.has-error:hover {
  color: #b66205;
}

.btn-outline-secondary {
  color: #333;
  border-color: #333;
}

.alt-source-chb {
  display: flex;
  gap: 5px;
  margin-bottom: -8px;
}
</style>
